function Loader(props) {

    return (
        <span className={typeof props.mtop != "undefined" && props.mtop ? "loader mtop-big" : "loader"}></span>
    )
}

export default Loader